class LicenseAddCommentCell extends UITableViewCell
{
    
}